import { go, pick } from 'fxjs/es';
import { UtilFxS } from '../../../../../Util/Fx/S/Function/module/UtilFxS.js';
import { UtilImageS } from '../../../../../Util/Image/S/Function/module/UtilImageS.js';
import format from 'date-fns/format/index.js';

/**
 * @dev feed 테이블 데이터를 brandedContent 형태에 맞게 변환
 * @return {editorial | null}
 */
export const transformFeedToBrandedContent = (feed) => {
  if (!feed) return null;

  const fields = [
    'id',
    'title',
    'title_en',
    'title_jp',
    'public_at',
    'thumbnail',
    'thumb_ratio',
    'slug',
    'content',
    'seo_title',
    'seo_description',
    'is_public',
    'show_home',
  ];

  const rename_object = {
    thumbnail: 'thumbnail_image',
  };

  return go(feed, pick(fields), UtilFxS.renameMultiple(rename_object));
};

/**
 * @typedef brandedContent
 * @property {string} title
 * @property {string} title_en
 * @property {string} sub_title
 * @property {number} view_counts
 * @property {string} public_at
 * @property {string} thumbnail_image
 * @property {string} slug
 * @property {string} content
 */

export const makeViewHtmls = (brandedContent) => {
  return {
    title: brandedContent.title.replace('\n', '<br/>'),
    title_en: brandedContent.title_en.replace('\n', '<br/>'),
    public_at: format(new Date(brandedContent.public_at), 'd MMMM yyyy'),
    thumbnail_image: UtilImageS.getResizedUrl({ url: brandedContent.thumbnail_image, format: 'webp' }),
  };
};
